<h2 mat-dialog-title>
  Create Sales Order Invoices
  <button mat-icon-button class="close-button" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div class="invoiceable-orders">
    <h5>Orders ready for invoicing</h5>
    <div class="list-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Order Date</th>
            <th>Order ID</th>
            <th>Order #</th>
            <th class="text-right">Total</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of forInvoicingOrders">
            <td>{{ order.orderDate | date: 'mediumDate' }}</td>
            <td>{{ order.id }}</td>
            <td>{{ order.orderNumber }}</td>
            <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
            <td>
              <span
                class="processing text-info"
                *ngIf="order.invoicingStatus === invoiceStatus.PROCESSING"
              >
                Processing <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span
                class="failed text-danger"
                *ngIf="order.invoicingStatus === invoiceStatus.FAILED"
              >
                FAILED
                <span *ngIf="order.invoicingError">
                  [{{ order.invoicingError }}]
                </span>
              </span>
              <span
                class="completed text-success"
                *ngIf="order.invoicingStatus === invoiceStatus.COMPLETED"
              >
                COMPLETED
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <h6 class="text-danger" *ngIf="!forInvoicingOrders.length">
    No orders can be invoiced
  </h6>
  <mat-divider></mat-divider>
  <div class="action text-right mb-3">
    <button mat-button type="button" [disabled]="loading" (click)="close()">
      Close
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="createInvoices()"
      [disabled]="loading || !forInvoicingOrders.length"
    >
      <mat-spinner
        *ngIf="loading"
        diameter="20"
        class="spinner-margin"
      ></mat-spinner>
      <span *ngIf="!loading"> Confirm and Create Invoices </span>
      <span *ngIf="loading"> Creating invoices, please wait...</span>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div *ngIf="cantBeInvoicedOrders.length">
    <h6 class="non-invoiceable">These orders can't be invoiced due to:</h6>
    <div class="list-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Order Date</th>
            <th>Order ID</th>
            <th>Order #</th>
            <th class="text-right">Total</th>
            <th class="text-right">Error(s)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of cantBeInvoicedOrders">
            <td>{{ order.orderDate | date: 'mediumDate' }}</td>
            <td>{{ order.id }}</td>
            <td>{{ order.orderNumber }}</td>
            <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
            <td class="text-right text-bold text-warning">
              {{ order.invoicingErrors?.join('\n') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>
